import { useMemo } from 'react';

// DEPENDENCIES
import camelCase from 'lodash/camelCase';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

// GLOBAL VARIABLES
import { GLOBAL_LOCAL, NEW_USED } from 'codes.js';
import { INTERFACE, RECORD } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions.js';

// MAIN COMPONENT
const useRecordView = () => {

  // REACT ROUTER
  const { pathname, search } = useLocation();

  // MEMOS
  const interfaceKey = useMemo(() => camelCase(pathname.match(/(?:\/)(.*?)(?=\/)/)?.[1]), [pathname]);
  const searchParams = useMemo(() => queryString.parse(search), [search]);
  const views = useMemo(
    () => ({
      isAdd: pathname.includes(makePath(RECORD.add)),
      isAdmin: pathname.includes(makePath(INTERFACE.settings)),
      isEdit: pathname.includes(makePath(RECORD.edit)),
      isGlobal: searchParams.global_local === undefined ? undefined : searchParams.global_local === String(GLOBAL_LOCAL.global.numeric),
      isNew: searchParams.new_used === undefined ? undefined : searchParams.new_used === String(NEW_USED.new.numeric),
      isView: pathname.includes(makePath(RECORD.view)),
      ...Object.keys(INTERFACE).reduce((acc, cur) => ({
        ...acc,
        [camelCase(`is_${cur}`)]: interfaceKey === cur
      }), {})
    }),
    [pathname, interfaceKey, searchParams]
  );
  const rootPathname = useMemo(
    () => {
      let output;
      Object.keys(RECORD).forEach(key => {
        if (pathname.includes(RECORD[key])) output = pathname.split(RECORD[key])[0];
      })
      return output;
    },
    [pathname]
  ) 

  return { ...views, interfaceKey, rootPathname, searchParams, view: interfaceKey };
};

// EXPORT
export default useRecordView;
